<template>
  <div>
    <!--  配送单待入金 -->
    <baseBreadcrumb :page="$t('message.porderWaitPaySubmit')" :menu="$t('message.porder')" />
    <porderBaseTable :status="30" />
  </div>
</template>
<script>
import porderBaseTable from "@/components/porder/porderBaseTable/index";
export default {
  components: { porderBaseTable },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped></style>